import { Petitum } from "src/app/common/models/petitum";
import { PropertiesSettings } from "src/app/core/configuration/properties-settings";

export function isPetitumValid(petitum: Petitum): boolean{
    let isPetitumValid = false;
    if(petitum && petitum.tipoPetitum){
        if (petitum.tipoPetitum.id == PropertiesSettings.ID_TIPO_PETITUM_QUANTIFICABILE) {
            const importoValid = petitum.importoPetitum !== null && petitum.importoPetitum !== undefined
            const dataInizioCalcoloInteressiValid = petitum.dataInizioCalcoloInteressi !== null && petitum.dataInizioCalcoloInteressi !== undefined
            isPetitumValid = importoValid && dataInizioCalcoloInteressiValid;
          } else {
            isPetitumValid = true;
          }
    }
    return isPetitumValid;
}